import { useCallback } from 'react'
import { useUser } from '$logic/users'
import { usePv } from '$logic/pv'
import { unBlockUser } from '$logic/user-policy'
import { t } from '$i18n'
import { SendField } from '../send-field'
import { ActionButton } from '../action-button'

export function PvFooter({ roomId }: { roomId: string }) {
  const { entity: pv } = usePv(roomId)
  const { user: { isBlocked } = { isBlocked: false }, loading } = useUser(
    pv?.to,
  )

  const onUnBlock = useCallback(() => {
    if (!pv?.to) return
    analite('BLOCK_USER', { active: false, source: 'PV_FOOTER' })
    unBlockUser(pv.to)
  }, [pv?.to])

  return loading || !pv ? null : !isBlocked ? (
    <SendField roomId={roomId} />
  ) : (
    <ActionButton
      text={t('menu.blockedUsers.unblocking')}
      onClick={onUnBlock}
    />
  )
}
